"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var helpers_1 = require("../../helpers");
function RequestBubble(_a) {
    var request = _a.request, rental = _a.rental;
    var rentalUnit = rental.rental_units.find(function (unit) { return unit.id == request.rental_unit_id; });
    var createMarkup = function (string) {
        return { __html: string };
    };
    return (react_1.default.createElement("div", { className: "message d-flex justify-content-start ms-3 mb-2 w-75 align-self-start gap-2 align-items-end" },
        react_1.default.createElement("div", { className: "chat-message-name-initials tooltip-trigger text smaller gray flex-shrink-0 mobile-hidden" },
            request.name.slice(0, 1).toUpperCase(),
            request.surname.slice(0, 1).toUpperCase(),
            react_1.default.createElement("span", { className: "tooltip nw p-1 text small shadow" }, "".concat(request.name, " ").concat(request.surname))),
        react_1.default.createElement("div", { className: "chat-message-bubble other-user d-flex flex-column" },
            react_1.default.createElement("span", { className: "strong mb-1" }, window.Translator.trans("chat.booking_request.request_from", { name: "".concat(request.name, " ").concat(request.surname) }, "js")),
            react_1.default.createElement("p", { className: "d-flex flex-column" },
                react_1.default.createElement("span", { className: "d-flex gap-2" },
                    react_1.default.createElement("svg", { className: "icon mb-0", width: "18", height: "18" },
                        react_1.default.createElement("use", { href: "#calendar" })),
                    (0, helpers_1.formatBookingRequestDate)(request.range_start),
                    " ",
                    request.range_end &&
                        " ".concat(window.Translator.trans("locale.to", {}, "js"), " ").concat((0, helpers_1.formatBookingRequestDate)(request.range_end))),
                react_1.default.createElement("span", { className: "d-flex gap-2" },
                    react_1.default.createElement("svg", { className: "icon mb-0", width: "20", height: "20" },
                        react_1.default.createElement("use", { href: "#people" })),
                    window.Translator.transChoice("chat.adults", request.adults, { count: request.adults }, "js"),
                    window.Translator.transChoice("chat.children", request.children, { count: request.children }, "js")),
                rentalUnit && (react_1.default.createElement("span", { className: "d-flex gap-2" },
                    react_1.default.createElement("svg", { className: "icon gray mb-0", width: "18", height: "18" },
                        react_1.default.createElement("use", { href: "#house" })),
                    react_1.default.createElement("span", { className: "d-flex gap-1" },
                        window.Translator.trans("units.type.singular.".concat(rentalUnit.type), {}, "js"),
                        react_1.default.createElement("a", { href: window.Routing.generate("rental_unit", {
                                rentalId: rental.id,
                                _locale: lang,
                            }), target: "_blank" },
                            "(",
                            rentalUnit.id,
                            ")")))),
                request.phone && (react_1.default.createElement("span", { className: "d-flex gap-2" },
                    react_1.default.createElement("svg", { className: "icon mb-0", width: "18", height: "18" },
                        react_1.default.createElement("use", { href: "#phone" })),
                    request.phone))),
            request.message ? (react_1.default.createElement("p", { className: "pb-0 text", dangerouslySetInnerHTML: createMarkup(request.message) })) : (react_1.default.createElement("p", { className: "p-2 pb-0" }, "(leer)")),
            react_1.default.createElement("span", { className: "text smaller gray align-self-end" }, (0, helpers_1.formatTimeMessage)(request.created)))));
}
exports.default = RequestBubble;
